"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRoundingPrecision = function (type, amount, precision) {
    var multiplier = Math.pow(10, precision || 0);
    switch (type) {
        case 'up':
            return Math.ceil(amount * multiplier) / multiplier;
        case 'down':
            return Math.floor(amount * multiplier) / multiplier;
        default:
            return typeof amount === 'number' ? amount : false;
    }
};
//# sourceMappingURL=get-rounding-precision.js.map